export const FILTER_TABS = [
  { id: 'all', label: 'All', value: 'all' },
  { id: 'profile', label: 'Profile', value: 'profile' },
  { id: 'contracts', label: 'Contracts', value: 'contracts' },
  { id: 'messages', label: 'Messages', value: 'messages' },
  { id: 'notifications', label: 'Notifications', value: 'notifications' },
];

export const TAB_VALUE = {
  ALL: 'all',
  PROFILE: 'profile',
  CONTRACT: 'contracts',
  MESSAGE: 'messages',
  NOTIFICATIONS: 'notifications',
};
